import { $body, $window } from '../global';
import { layoutManager } from './layout';
import { pageEventsManager } from './page-events';
class MainMenuManager {
    menu;
    sub;
    items;
    lastEventTime;
    eventDelay = 400;
    delayedActivateItem;
    delayedActivateItemTimeout;
    hasTouch = false;
    init(menu, sub) {
        this.lastEventTime = Date.now();
        this.menu = menu;
        this.sub = sub;
        this.items = this.menu.find('.MainNav_Item');
        $window.on('touchstart.noPreventDefault.MainMenu', () => {
            this.hasTouch = true;
            $window.off('touchstart.noPreventDefault.MainMenu');
        });
        /// / MENUITEMS
        // HOVER
        this.items.parent().on('mouseenter.MainMenu', (e) => {
            if (this.isMobileMenu())
                return;
            this.updateLastEventTime();
            const item = $(e.currentTarget).children('.MainNav_Item');
            this.delayActivateItem(item);
        });
        this.items.parent().on('mouseleave.MainMenu', () => {
            if (this.isMobileMenu())
                return;
            this.updateLastEventTime();
            this.unactivateAllItems();
        });
        this.items.add(this.items.parent()).on('mousemove.MainMenu', () => {
            if (this.isMobileMenu())
                return;
            if (this.delayedActivateItemTimeout == null)
                return;
            this.delayActivateItem(this.delayedActivateItem);
        });
        // ACTIVATION
        this.items.on('mousedown.MainMenu', (e) => {
            if (this.isMobileMenu() || this.hasTouch)
                return;
            this.gotoItem($(e.currentTarget));
        });
        this.items.on('mousedown.MainMenu touchend.MainMenu', (e) => {
            if (this.preventExecution(true))
                return;
            const item = $(e.currentTarget);
            if (this.isMobileMenu()) {
                const clickedArrow = e.target.classList.contains('MenuItem_Arrow');
                if (!clickedArrow) {
                    this.gotoItem(item);
                    return;
                }
            }
            if (this.itemIsActive(item)) {
                this.unactivateMenu();
                this.unactivateAllItems();
                if (this.isMobileMenu())
                    return;
                this.gotoItem(item);
            }
            else {
                this.activateItem(item);
            }
        });
        $window.on('touchend.MainMenu mousedown.MainMenu', (e) => {
            if (this.preventExecution(true) || this.isMobileMenu())
                return;
            if (this.isInsideMenu(e.target))
                return;
            this.unactivateMenu();
        });
        this.items.on('focus.MainMenu', (e) => {
            if (this.preventExecution(true))
                return;
            this.activateItem($(e.currentTarget));
        });
        /// / MENU
        this.menu.on('focusout.MainMenu', () => {
            setTimeout(() => {
                if (this.preventExecution() || this.isMobileMenu() || this.isInsideMenu(document.activeElement))
                    return;
                this.unactivateMenu();
            }, 0);
        });
        this.menu.on('mouseleave.MainMenu', () => {
            this.unactivateMenu();
        });
        this.menu.find('.CloseTrigger').on('mouseenter.MainMenu', () => {
            this.unactivateMenu();
        });
        pageEventsManager.on('beforepageunload', () => {
            this.unactivateMenu();
        });
    }
    delayActivateItem(element) {
        this.resetDelayedActivateItemTimeout();
        if (this.menu.hasClass('Active')) {
            this.activateItem(element);
        }
        else {
            this.delayedActivateItem = element;
            this.delayedActivateItemTimeout = window.setTimeout(() => {
                this.activateItem(element);
            }, 50);
        }
    }
    resetDelayedActivateItemTimeout() {
        if (this.delayedActivateItemTimeout == null)
            return;
        clearTimeout(this.delayedActivateItemTimeout);
        this.delayedActivateItemTimeout = null;
    }
    isInsideMenu(element) {
        if (!this.menu.length)
            return false;
        return $.contains(this.menu[0], element) && !$(element).hasClass('CloseTrigger');
    }
    activateMenu() {
        if (this.isMobileMenu() || this.menu.hasClass('Active'))
            return;
        layoutManager.isUnactive();
        this.menu.addClass('Active');
        $body.addClass('MenuIsActive');
    }
    unactivateMenu() {
        if (this.isMobileMenu() || !this.menu.hasClass('Active'))
            return;
        this.unactivateAllItems();
        this.menu.removeClass('Active');
        $body.removeClass('MenuIsActive');
    }
    updateLastEventTime() {
        this.lastEventTime = Date.now();
    }
    preventExecution(updateTime = false) {
        const prevent = this.lastEventTime + this.eventDelay > Date.now();
        if (updateTime)
            this.updateLastEventTime();
        return prevent;
    }
    itemIsActive(item) {
        return item.parent().hasClass('Active');
    }
    activateItem(item) {
        this.unactivateAllItems();
        this.activateMenu();
        this.items.parent().addClass('Inactive');
        item.parent().removeClass('Inactive').addClass('Active');
        if (this.isMobileMenu())
            this.menu.animate({ scrollTop: 0 }, 250);
    }
    unactivateAllItems() {
        this.resetDelayedActivateItemTimeout();
        this.items.parent().removeClass('Inactive').removeClass('Active');
    }
    gotoItem(item) {
        const url = item.data('url');
        if (url)
            pageEventsManager.navigateTo(url, '_self');
    }
    isMobileMenu() {
        return window.innerWidth < 768;
    }
}
const mainMenuManager = new MainMenuManager();
window.mainMenuManager = mainMenuManager;
export { MainMenuManager, mainMenuManager };
